module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/common-script/common-script.component.html
// module id = ../../../../../src/app/common-script/common-script.component.html
// module chunks = main